import { render } from "./BlankLayout.vue?vue&type=template&id=5291c0af"
const script = {}

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/BlankLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5291c0af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5291c0af', __exports__)) {
    api.reload('5291c0af', __exports__)
  }
  
  module.hot.accept("./BlankLayout.vue?vue&type=template&id=5291c0af", () => {
    api.rerender('5291c0af', render)
  })

}


export default __exports__